import { assign } from './utils/lodash';

const config = assign({
  development: {
    api: {
      tariff_rates: {
        host: 'https://data.mds.dev2.trade.gov/fta_tariff_rates/v1',
        subscription_key: 'e36b676e132b433387556a0a3500de30'
      },
    },
  },
  production: {
    api: {
      tariff_rates: {
        host: 'https://data.trade.gov/fta_tariff_rates/v1',
        subscription_key: '06800b3aa7914d61a9e770d671eda3c8'
      },
    },
  },
});

export default config[process.env.NODE_ENV];
